import React, { useEffect, useState } from "react";
import { requestEndpoint } from "../../../data/requestEndpoint";
import pencilIcon from "../../../images/icons/edit-02.svg";
import { useGetDelayRequest } from "../../../services/useFetchAction";
import {
  findVersementMethod,
  handleHideSomeNumberInRib,
  handleSepareContact,
} from "../../../services/utils";
import { useStorePageManager } from "../../../store/PageManage";
import "../../../styles/components/versement-select.css";
import ContainerPersoModal from "../../biggest/ContainerPersoModal";
import ModifVersement from "./ModifVersement";
export default function ChangeVersementMethod({
  handleOutModal,
  handleUpdateUser,
  isReservationHote = false,
  t,
  setNoOpacity,
  reservation,
  currentPaiementInfo,
  directAccept,
}) {
  const [currentSelectedPaiementInfo, setCurrentSelectedPaiementInfo] =
    useState();
  const [userVersementMethodData, setUserVersementMethodData] = useState([]);
  // eslint-disable-next-line no-unused-vars
  const [dataVersement, loadingVersement, errorVersement, fetchDataVersement] =
    useGetDelayRequest({
      route: requestEndpoint.getHoteVersement,
      delay: 0,
      loadingTime: 0,
    });
  useEffect(() => {
    fetchDataVersement();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const [tempVersementData, setTempVersementData] = useState([]);
  useEffect(() => {
    if (dataVersement?.data) {
      setUserVersementMethodData(dataVersement?.data);
    }
    if (!loadingVersement) {
      let tempVersement = JSON.parse(
        sessionStorage.getItem("temporaryVersement")
      );

      if (tempVersement) {
        setTempVersementData(tempVersement);
      }
    }
  }, [dataVersement, loadingVersement]);

  const [panelSelectOption, setPanelSelectOption] = useState(false);
  useEffect(() => {
    if (setNoOpacity) setNoOpacity(panelSelectOption);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [panelSelectOption]);
  const [forAddVersement, setForAddVersement] = useState(false);
  const [editPanelOpen, setEditPanelOpen] = useState(false);

  const [currentPaiementInfoSelect, setCurrentPaiementInfoSelect] = useState();

  const handleOpenEditPanel = (selected, force) => {
    setCurrentPaiementInfoSelect(
      findVersementMethod(selected?.payment_method_id)
    );
    setCurrentSelectedPaiementInfo(selected);

    // console.log(selected);
    setForAddVersement(false);
    if (isReservationHote && !force) {
      setPanelSelectOption(true);
      return;
    }
    setEditPanelOpen(!editPanelOpen);
  };
  const handleOpendEditPanelForAdd = () => {
    setForAddVersement(true);
    setCurrentSelectedPaiementInfo(null);
    setEditPanelOpen(!editPanelOpen);
  };
  return (
    <>
      {loadingVersement || errorVersement ? (
        <div className="maxwidth flcolm addgap8 center">
          <label>{t("modals.personalInfo.paiementMethod.loading")}</label>
          <div class="lds-ripple-load">
            <div></div>
            <div></div>
          </div>
        </div>
      ) : userVersementMethodData.length === 0 ? (
        <label>
          {t("modals.personalInfo.paiementMethod.noPaiementMethod")}
        </label>
      ) : isReservationHote ? (
        <div className="flcolm addgap8">
          {userVersementMethodData.length >= 1 && directAccept ? (
            <label>
              <strong
                className="flash-me"
                style={{
                  fontSize: 16,
                  fontWeight: 600,
                }}
              >
                {t("modals.personalInfo.paiementMethod.comment")}
              </strong>
              {/* ) ? */}
            </label>
          ) : (
            <label>
              <strong
                className="flash-me"
                style={{
                  fontSize: 16,
                  fontWeight: 600,
                }}
              >
                {t("modals.personalInfo.paiementMethod.comment")}
              </strong>
              {/* ) ? */}
            </label>
          )}
        </div>
      ) : userVersementMethodData.length === 1 ? (
        <label>{t("modals.personalInfo.paiementMethod.oneMethod")}</label>
      ) : (
        <label>{t("modals.personalInfo.paiementMethod.canModify")}</label>
      )}
      {!loadingVersement && !errorVersement && (
        <div className="maxwidth flcolm addgap8">
          {userVersementMethodData.map((item, index) => (
            <div className="maxwidth rlve">
              <button
                key={index + "paiement-btn"}
                style={{}}
                onClick={() => handleOpenEditPanel(item)}
                className={`btn flrow liner btn-select-defaut  ${
                  item.default ? "active" : ""
                }`}
              >
                <img
                  src={`${process.env.REACT_APP_API_URL}${
                    process.env.REACT_APP_LINK_PAIEMENT
                  }${findVersementMethod(item.payment_method_id)?.icon}`}
                  alt="paiement-method"
                />
                <div className="flcolm details">
                  <h3 className="flrow addgap8 liner">
                    {findVersementMethod(item.payment_method_id)?.label}
                    {item.temporary && (
                      <span
                        className="flash-me"
                        style={{
                          color: "var(--gray-500)",
                          fontSize: 12,
                          fontWeight: "600",
                        }}
                      >
                        (temporaire)
                      </span>
                    )}
                  </h3>
                  <p>
                    {item?.infos?.rib
                      ? handleHideSomeNumberInRib(item?.infos?.rib)
                      : `+(${item?.infos?.indicatif}) ${handleSepareContact(
                          item?.infos?.contact
                        )}`}
                  </p>
                </div>
                {item.default && !isReservationHote ? (
                  <span>{t("modals.personalInfo.paiementMethod.default")}</span>
                ) : (
                  ""
                )}
              </button>
              {isReservationHote && (
                <button
                  style={{
                    padding: 8,
                    borderRadius: "50%",
                    position: "absolute",
                    top: "50%",
                    right: 20,
                    transform: "translateY(-50%)",
                    backgroundColor: "var(--gray-200)",
                  }}
                  onClick={() => handleOpenEditPanel(item, true)}
                  className="btn"
                >
                  <img src={pencilIcon} alt="pencil-icon" />
                </button>
              )}
            </div>
          ))}
          {tempVersementData.map((item, index) => (
            <div className="maxwidth rlve">
              <button
                key={index + "paiement-btn-temp"}
                style={{}}
                onClick={() => handleOpenEditPanel(item)}
                className={`btn flrow liner btn-select-defaut`}
              >
                <img
                  src={`${process.env.REACT_APP_API_URL}${
                    process.env.REACT_APP_LINK_PAIEMENT
                  }${findVersementMethod(item.payment_method_id)?.icon}`}
                  alt="paiement-method"
                />
                <div className="flcolm details">
                  <h3 className="flrow addgap8 liner">
                    {findVersementMethod(item.payment_method_id)?.label}
                    {item.temporary && (
                      <span
                        className="flash-me"
                        style={{
                          color: "var(--gray-500)",
                          fontSize: 12,
                          fontWeight: "600",
                        }}
                      >
                        (temporaire)
                      </span>
                    )}
                  </h3>
                  <p>
                    {item?.infos?.rib
                      ? handleHideSomeNumberInRib(item?.infos?.rib)
                      : `+(${item?.infos?.indicatif}) ${handleSepareContact(
                          item?.infos?.contact
                        )}`}
                  </p>
                </div>
              </button>
              {isReservationHote && (
                <button
                  style={{
                    padding: 8,
                    borderRadius: "50%",
                    position: "absolute",
                    top: "50%",
                    right: 20,
                    transform: "translateY(-50%)",
                    backgroundColor: "var(--gray-200)",
                  }}
                  onClick={() => handleOpenEditPanel(item, true)}
                  className="btn"
                >
                  <img src={pencilIcon} alt="pencil-icon" />
                </button>
              )}
            </div>
          ))}

          {!loadingVersement &&
            !errorVersement &&
            userVersementMethodData.length <= 9 && (
              <button
                onClick={handleOpendEditPanelForAdd}
                className="btn flrow liner btn-select-defaut btn-action"
              >
                <span
                  style={{
                    fontSize: 16,
                    margin: 0,
                    border: "none",
                  }}
                >
                  {t("modals.personalInfo.paiementMethod.addNewMethod.p1")}{" "}
                  <strong style={{ margin: 0 }}>
                    {t("modals.personalInfo.paiementMethod.addNewMethod.p2")}
                  </strong>{" "}
                  {t("modals.personalInfo.paiementMethod.addNewMethod.p3")}
                </span>
              </button>
            )}
        </div>
      )}

      <ContainerPersoModal
        isOpen={editPanelOpen}
        toggle={setEditPanelOpen}
        title={
          forAddVersement
            ? t(
                "modals.personalInfo.paiementMethod.modals.addNewMethod.addTitle"
              )
            : t(
                "modals.personalInfo.paiementMethod.modals.addNewMethod.editTitle"
              )
        }
        className="modal-edit-paiement"
        fullBlock={true}
        noOverflow={true}
        // bottomChildren={true}
        brum={true}
        overContent={true}
      >
        <ModifVersement
          t={t}
          data={currentSelectedPaiementInfo}
          userDataVersement={userVersementMethodData}
          setDataVersement={setUserVersementMethodData}
          setEditPanelOpen={setEditPanelOpen}
          fetchDataVersement={fetchDataVersement}
          typeEdit={!forAddVersement}
          inReservationPanel={isReservationHote}
          tempVersementData={tempVersementData}
          setTempVersementData={setTempVersementData}
        />
      </ContainerPersoModal>
      <ContainerPersoModal
        title={t(
          "modals.personalInfo.paiementMethod.modals.confirmMethod.title"
        )}
        isOpen={panelSelectOption}
        toggle={setPanelSelectOption}
        className="modal-edit-paiement confirmation just-modal"
        fullBlock={true}
        noOverflow={true}
        brum={true}
      >
        <div
          style={{
            width: 250,
          }}
          className="flcolm addgap8"
        >
          <span className="just-t">
            {t(
              "modals.personalInfo.paiementMethod.modals.confirmMethod.description"
            )}
          </span>
          <span
            style={{
              fontWeight: 500,
            }}
            className="just-t"
          >
            {currentPaiementInfoSelect && (
              <strong>{currentPaiementInfoSelect.label} </strong>
            )}
            {"-> "}
            {currentPaiementInfoSelect &&
            currentPaiementInfoSelect?.id === 7 ? (
              <>
                {t(
                  "modals.personalInfo.paiementMethod.modals.confirmMethod.infos.p1"
                )}{" "}
                <strong className="flash-me">
                  {t(
                    "modals.personalInfo.paiementMethod.modals.confirmMethod.infos.days1"
                  )}
                </strong>{" "}
                <span
                  style={{
                    textDecoration: "underline",
                    textUnderlineOffset: "2px",
                  }}
                >
                  {" "}
                  {t(
                    "modals.personalInfo.paiementMethod.modals.confirmMethod.infos.p2"
                  )}
                </span>
              </>
            ) : (
              <>
                {t(
                  "modals.personalInfo.paiementMethod.modals.confirmMethod.infos.p1"
                )}{" "}
                <strong className="flash-me">
                  {t(
                    "modals.personalInfo.paiementMethod.modals.confirmMethod.infos.days2"
                  )}
                </strong>
                <span
                  style={{
                    textDecoration: "underline",
                    textUnderlineOffset: "2px",
                  }}
                >
                  {" "}
                  {t(
                    "modals.personalInfo.paiementMethod.modals.confirmMethod.infos.p2"
                  )}
                </span>
              </>
            )}
            .
          </span>
          <button
            onClick={() => {
              useStorePageManager.getState().handleUpdateBlockScreen(true);
              handleOutModal(currentSelectedPaiementInfo, true);
            }}
            style={{
              borderRadius: 8,
            }}
            className="btn pry-btn"
          >
            <span
              style={{
                fontWeight: "bold",
              }}
            >
              {t("modals.personalInfo.paiementMethod.modals.button.confirm")}
            </span>
          </button>
        </div>
      </ContainerPersoModal>
    </>
  );
}
